// The keys `useTenantSetting` reads; the names are the tenant-settings JSON keys verbatim.
export const PAYMENTS_BATCH = 'paymentsBatch'
export const OPTIMIZE_STOPS = 'optimizeStops'
export const ROUTE_MANAGER_AUTO_POLLING = 'routeManagerAutoPolling'
export const INVENTORY = 'inventory'
export const VISION = 'vision'
export const VISION_REVIEW = 'visionReview'
export const MESSAGING = 'messaging'
export const HERO_ANALYTICS = 'heroAnalytics'
export const NEW_TAXES_ENABLED = 'newTaxesEnabled'
export const LEGACY_TAXES_ENABLED = 'legacyTaxesEnabled'
export const PROMOTE_DAILY_TO_MASTER = 'promoteDailyToMaster'
export const INVENTORY_PLACEMENTS = 'inventoryPlacements'
export const ROUTE_PRODUCTIVITY_REPORT = 'routeProductivityReport'
export const ACCOUNT_LIFECYCLE_CAPTURE = 'accountLifecycleCaptureEnabled'
export const ROUTE_MANAGER_V3 = 'routeManagerV3'
export const ROUTE_OPTIMIZATION_ASYNC = 'routeOptimizationAsync'
export const ROUTE_SERVICE_TIME_WINDOWS = 'routeServiceTimeWindows'
export const DIALSTACK_SCREEN_POP = 'dialstackScreenPop'
